import { render, staticRenderFns } from "./notesRep.vue?vue&type=template&id=60704a6d&"
import script from "./notesRep.vue?vue&type=script&lang=js&"
export * from "./notesRep.vue?vue&type=script&lang=js&"
import style0 from "./notesRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports